import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrendingStrip from './components/TrendingStrip';
import DeepSection from './components/DeepSection';
import InterviewSection from './components/InterviewSection';
import CategoryFeed from './components/CategoryFeed';
import TopicSection from './components/TopicSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';
import { faqs } from '@/mocks/news';
import BackTop from './components/BackTop';

const TITLE = '吃瓜新闻｜热点深度报道 · 独家专访 · 还原事件本质';
const DESC =
  '吃瓜新闻深度报道频道，提供热点事件复盘、独家专访与行业揭秘。多信源交叉核实，区分事实与观点，带你了解热搜背后真实的来龙去脉与深层逻辑。';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertJsonLd(id: string, data: unknown) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    (el as HTMLScriptElement).type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Home() {
  useEffect(() => {
    document.title = TITLE;
    upsertMeta('name', 'description', DESC);
    upsertMeta('name', 'keywords', '吃瓜新闻,吃瓜新闻深度报道,吃瓜新闻独家专访,吃瓜新闻揭秘,热点事件复盘');
    upsertMeta('name', 'robots', 'index, follow');
    upsertMeta('property', 'og:title', TITLE);
    upsertMeta('property', 'og:description', DESC);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:locale', 'zh_CN');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', TITLE);
    upsertMeta('name', 'twitter:description', DESC);

    upsertJsonLd('ld-org', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '吃瓜新闻',
      description: DESC,
    });
    upsertJsonLd('ld-web', {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '吃瓜新闻',
      inLanguage: 'zh-CN',
      description: DESC,
    });
    upsertJsonLd('ld-webpage', {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: TITLE,
      description: DESC,
      inLanguage: 'zh-CN',
    });
    upsertJsonLd('ld-faq', {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrendingStrip />
        <DeepSection />
        <InterviewSection />
        <CategoryFeed />
        <TopicSection />
        <AboutSection />
        <FaqSection />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}